// eslint-disable-next-line no-unused-vars
import React from 'react';
import { func, bool, string, number } from 'prop-types';
import { Button } from '@carbon/react';
import uniqueId from 'lodash/uniqueId';
import styled from '@emotion/styled';
import { useTranslation } from 'react-i18next';
import { Minus, Plus } from 'lucide-react';

import useWheelHack from 'Hooks/useWheelHack';

const StyledNumberInput = styled.div`
  ${ props => {
    if (props.disabled) {
      return `
        // width: 40px;
        // min-width: 0 !important;
        // height: 40px;
        // min-height: 0 !important;
      `;
    }
    if (props.size === 'xl') {
      return `
        width: 150px;
        height: 50px;
      `;
    }

    if (props.size === 'lg') {
      return `
        width: 98px;
        height: 40px;
      `;
    }
    if (props.size === 'md') {
      return `
        width: 90px;
        height: 35px;
      `;
    }
    return `
      width: 75px;
      height: 25px;
    `;
  } }
  min-width: 80px;
  max-width: 150px;
  min-height: 25px;
  max-height: 50px;
  display: flex;
  align-items: center;
  justify-content: space-between;

  .quantitySelect {
    &:first-of-type:after,
    &:last-of-type:before {
      position: absolute;
      top: 14%;
      content: '';
      display: block;
      width: 1px;
      height: 80%;
      background-color: ${ props => props.theme.products.colors.border };
    }

    &:first-of-type {
      border-right: 0;

      &:after {
        right: 0;
      }
    }

    &:last-of-type {
      border-left: 0;

      &:before {
        left: 0;
      }
    }

    position: relative;
    height: 100%;
    min-width: 25px;
    min-height: 25px;
    margin: 0;
    padding: 0;
    border: 1px solid ${ props => props.theme.products.colors.border };
    outline: 0;
    box-shadow: none;
    display: flex;
    justify-content: center;
    align-content: center !important;
    width: 30%;
    color: ${ props => props.theme.colors.gray };

    svg {
      margin: 0;
    }
  }

  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  /* Firefox */

  input[type=number] {
    -moz-appearance: textfield;
  }

  input {
    &:disabled {
      //height: 100%;
      //width: 100%;
      margin: 0 auto;
      border: 1px solid ${ props => props.theme.products.colors.border };
    }

    min-width: 30px;
    min-height: 25px;
    padding: 0;
    border-radius: 0;
    box-sizing: border-box;
    outline: 0 !important;
    text-align: center;
    font-size: 1rem;
    color: ${ props => props.theme.colors.darkGray };
    line-height: 14px;
    border-top: 1px solid ${ props => props.theme.products.colors.border };
    border-bottom: 1px solid ${ props => props.theme.products.colors.border };
    border-left: 0;
    border-right: 0;
    position: relative;
    width: 100%;
  }
`;

const QuantitySelect = (
  { onClick, onInputChange, value, size, step, min, max, disabled, zeroAllowed, ...rest }
) => {
  const { t } = useTranslation();
  const preventWheel = useWheelHack();

  return (
    <StyledNumberInput
      className="quantitySelector"
      size={ size }
      disabled={ disabled }
      { ...rest }
    >
      { !disabled && (
        <Button
          className="quantitySelect decrease"
          kind="ghost"
          title={ t('cart.decrease') }
          aria-label={ t('cart.decrease') }
          tabIndex={ 0 }
          onClick={ () => onClick(Math.max(zeroAllowed ? 0 : 1, value - step)) }
          renderIcon={ Minus }
          iconDescription="decrease"
        />
      ) }
      <input
        type="number"
        tabIndex={ 0 }
        id={ uniqueId('quantitySelector') }
        min={ Math.max(0, min) }
        step={ step }
        max={ max }
        aria-label="Numeric input field with increment and decrement buttons"
        value={ value }
        onChange={ onInputChange }
        disabled={ disabled }
        ref={ preventWheel }
      />
      { !disabled && (
        <Button
          className="quantitySelect increase"
          kind="ghost"
          title={ t('cart.increase') }
          aria-label={ t('cart.increase') }
          tabIndex={ 0 }
          onClick={ () => onClick(Math.min(max, value + step)) }
          renderIcon={ Plus }
          iconDescription="increase"
        />
      ) }
    </StyledNumberInput>
  );
};

QuantitySelect.propTypes = {
  onClick: func,
  onInputChange: func,
  // onWheel: func,
  size: string,
  value: number,
  zeroAllowed: bool,
  disabled: bool,
  step: number,
  min: number,
  max: number
};

export default QuantitySelect;
